import { put, call, takeLatest, select, all } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import publicationsAPI from '../../api/publications';
import { Types, Creators as PublicationCreators } from '../../reducers/publications';
import { getState } from '../../utils/getState';

function* requestPublications(page, category) {
  const { app, product } = yield select(getState);
  const siteId = app.getIn(['config', 'siteId']);

  const productId = product.getIn(['id']);

  if (page === 'category') {
    return yield all(
      app
        .getIn(['config', 'positions', page], [])
        .filter((item) => item.show && item.type === 'publishes')
        .map(({ id }) => {
          return call(publicationsAPI.category, id, category, siteId);
        })
    );
  }

  if (page === 'product') {
    return yield call(publicationsAPI.product, productId, siteId);
  }

  return yield call(
    publicationsAPI.home,
    {
      positions: app
        .getIn(['config', 'positions', page], [])
        .filter((item) => item.show && item.type === 'publishes')
        .map((item) => item.id)
        .join(','),
    },
    siteId
  );
}

function* getPublications({ page = 'home', category = null }) {
  try {
    const publishes = {};
    const data = yield call(requestPublications, page, category);

    if (!isEmpty(data)) {
      data.forEach((item) => {
        publishes[item.position] = { ...item };
      });
    }

    yield put(PublicationCreators.getPublicationsSuccess({ publishes }));
  } catch (error) {
    yield put(PublicationCreators.getPublicationsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_PUBLICATIONS_REQUEST, getPublications);
}
